import { render, staticRenderFns } from "./BAppleSignIn.vue?vue&type=template&id=60260b28&scoped=true"
import script from "./BAppleSignIn.vue?vue&type=script&setup=true&lang=ts"
export * from "./BAppleSignIn.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BAppleSignIn.vue?vue&type=style&index=0&id=60260b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60260b28",
  null
  
)

export default component.exports